
export default function Footer() {
  const socialLinks = [
    { icon: 'ri-facebook-fill', href: '#', name: 'Facebook' },
    { icon: 'ri-instagram-line', href: '#', name: 'Instagram' },
    { icon: 'ri-whatsapp-line', href: '#', name: 'WhatsApp' },
    { icon: 'ri-mail-line', href: '#', name: 'Email' }
  ];

  return (
    <footer id="contacto" className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Logo y descripción */}
          <div>
            <h3 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
              Castilletes Parque Tayrona
            </h3>
            <p className="text-gray-300 mb-6 max-w-md">
              Tu oasis frente a Playa Castilletes. Vive la magia del Tayrona con comodidad, 
              donde la naturaleza y el confort se encuentran en perfecta armonía.
            </p>
            <div className="flex space-x-4">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.href}
                  className="w-10 h-10 bg-teal-600 rounded-full flex items-center justify-center hover:bg-teal-700 transition-colors cursor-pointer"
                  title={social.name}
                >
                  <i className={`${social.icon} text-lg`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Información de Contacto */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contacto</h4>
            <div className="space-y-2">
              <p className="text-gray-300 flex items-center">
                <i className="ri-phone-line mr-2"></i>
                +57 319 615 2352
              </p>
              <p className="text-gray-300 flex items-center">
                <i className="ri-mail-line mr-2"></i>
                campingcastilletestayrona@gmail.com
              </p>
              <p className="text-gray-300 flex items-start">
                <i className="ri-map-pin-line mr-2 mt-1"></i>
                Dentro del Parque Tayrona. Km 3.5 entre Zaino y Cañaveral, El Zaino, Santa Marta, Magdalena
              </p>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-800 mt-12 pt-8">
          <p className="text-gray-400 text-sm text-center">
            © 2025 Castilletes Parque Tayrona. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
}
